<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">Admin Details</template>
        <!-- <b-container v-if="report"> -->
        <div v-if="user">
          <b-row v-if="user.photo" class="py-2 justify-content-md-center">
            <b-col cols="12" class="text-center">
              <img :src="baseURL+'/u/'+user.photo" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.name}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>

            <!-- <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Username</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.username">{{user.username}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col> -->

            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.phone">{{user.phone}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="4" md="5">
                  <span class="item_title">Email</span>
                </b-col>
                <b-col cols="8" md="7">
                  <span class="item_value" v-if="user.email">{{user.email}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Role</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.role">{{user.role}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User Status</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value" v-if="user.status">{{user.status}}</span>
                  <span v-else class="item_value">-</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            
            
           
          </b-row>
        </div>
        <b-row v-if="userRole=='admin' && (userType== 0 || userType==1)" class="justify-content-center">
          <!-- <div class="px-2">
            <b-button variant="outline-primary" size="sm" :to="'/EditUser/'+$route.params.id">Edit</b-button>
          </div> -->
          
          <div class="px-2">
            <b-button variant="danger" size="sm" @click.prevent="confirmRemoveUser">Remove Admin</b-button>
          </div>
          
          <div v-if="userStatus=='Pending'" class="px-2">
            <b-button
              @click="show=true"
              variant="primary"
              size="sm"
              v-b-modal.modal-center
            >Approve User</b-button>
            <b-modal  v-model="show" centered>
              <b-container fluid>
                <b-row>
                  <b-col cols="12" md="12">
                    <!-- <div :class="{error: validation.hasError('role')}"> -->
                    <b-form-group label="Role">
                      <b-form-select v-model="role" :options="userTypes"></b-form-select>
                      <!-- <template slot="description" v-if="validation.firstError('role')">
                        <span style="color:red;">{{validation.firstError('role')}}</span>
                      </template>-->
                    </b-form-group>
                    <!-- </div> -->
                  </b-col>
                  <b-col cols="12" md="12">
                    <b-form-group label="Division *">
                      <b-form-select
                        :disabled="userRole=='Manager'?true:false"
                        v-model="division"
                        :options="divisions"
                        text-field="name"
                        value-field="_id"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="role=='Informant' || role=='Subscriber'" cols="12" md="12">
                    <b-form-group label="Range *">
                      <b-form-select
                        v-model="range"
                        :options="ranges"
                        text-field="name"
                        value-field="_id"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>

              <template v-slot:modal-footer>
                <div class="w-100">
                  <b-button
                    variant="primary"
                    size="sm"
                    class="float-right"
                    @click="approveUser"
                  >Approve</b-button>
                </div>
              </template>
            </b-modal>
          </div>
          <div v-if="userStatus=='Pending'" class="px-2">
            <b-button
              @click="Reject=true"
              variant="danger"
              size="sm"
              class="pl-2"
             
            >Reject User</b-button>
            <b-modal v-model="Reject" centered>
              <b-container fluid>
                <b-row>
                  <b-col cols="12" md="12">
                    <!-- <div :class="{error: validation.hasError('role')}"> -->
                    <b-form-group label="Reply">
                      <b-form-textarea id="textarea-small" size="sm" v-model="reason" placeholder="Enter Reason"></b-form-textarea>
                      <!-- <template slot="description" v-if="validation.firstError('role')">
                        <span style="color:red;">{{validation.firstError('role')}}</span>
                      </template>-->
                    </b-form-group>
                    <!-- </div> -->
                  </b-col>
                </b-row>
              </b-container>

              <template v-slot:modal-footer>
                <div class="w-100">
                  <b-button
                    variant="primary"
                    size="sm"
                    class="float-right"
                    @click="rejectUser"
                  >Submit</b-button>
                </div>
              </template>
            </b-modal>
          </div>
        </b-row>
        <!-- </b-container> -->
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: null,
      show: false,
      Reject: false,
      reason: null,
      appLoading: false,
      ServerError: false,
      userStatus: null,
      userType: localStorage.getItem("usrType"),
      userRole: localStorage.getItem("role"),
      userTypes: ["Researcher", "Manager", "Informant", "Subscriber"],
      role: 'Informant',
      divisions: [],
      division: null,
    };
  },
  mounted() {
    this.getData();
    
  },
  
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/view/"+this.$route.params.id,
        // params: {
        //   id: this.$route.params.id,
        // },
        headers: {
          "token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.userStatus = this.user.status;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
   
    confirmDeactivateUser(item) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to " + item + " this user.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.deactivateUser();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    confirmRemoveUser() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to Remove this admin. All data will be lost for this admin",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.removeUser();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    deactivateUser() {
      this.appLoading = true;
      var newURL;
      if (this.userStatus == "Banned") {
        // this.userStatus = "Active";
        newURL = "user/activateuser";
      } else if (this.userStatus == "Active") {
        // this.userStatus = "Banned";
        newURL = "user/banuser";
      }
      axios({
        method: "POST",
        // url: "/user/banuser",
        url: newURL,
        data: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.getData();
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    approveUser() {
      axios({
        method: "POST",
        url: "/user/approve",
        data: {
          id: this.$route.params.id,
          role: this.role,
          division: this.division,
          range: this.range,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // this.getData();
          this.show = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    rejectUser() {
      axios({
        method: "POST",
        url: "/user/reject",
        data: {
          id: this.$route.params.id,
          reason: this.reason,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // this.getData();
          this.Reject = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    removeUser() {
      axios({
        method: "POST",
        url: "/admin/delete/"+this.$route.params.id,
        // data: {
        //   id: this.$route.params.id,
        // },
        headers: {
          "token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // this.getData();
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>